// extracted by mini-css-extract-plugin
export default {"errorTile":"DRReenpGWKlETHlyapES","text":"jRq7YKDkvbKH3Eu4lrq0"};